export default "__VITE_ASSET__9528e05b__"